import dynamic from 'next/dynamic'

import {
  BabyGrowthPageProps,
  BabyGrowthPageType,
} from 'components/pages/healthTools/babyGrowth/index'
import { BabyGrowthResultPageProps } from 'components/pages/healthTools/babyGrowth/result'
import { Props as BabyPoopPageProps } from 'components/pages/healthTools/babyPoop'
import { BabyVaccinationPageAllProps } from 'components/pages/healthTools/babyVaccine'
import { Props as BMIPageProps } from 'components/pages/healthTools/bmi'
import { Props as BMRPageProps } from 'components/pages/healthTools/bmr'
import { Props as DueDatePageProps } from 'components/pages/healthTools/due-date'
import { Props as OvulationPageProps } from 'components/pages/healthTools/ovulation'
import { Props as PWGPageProps } from 'components/pages/healthTools/pwg'
import { Props as THRPageProps } from 'components/pages/healthTools/thrPage'
export const DueDatePageComponent = dynamic<DueDatePageProps>(() =>
  import('components/pages/healthTools/due-date').then(
    (mod) => mod.DueDatePageComponent,
  ),
)

export const BMIPageComponent = dynamic<BMIPageProps>(() =>
  import('components/pages/healthTools/bmi').then((mod) => mod.BMIToolPage),
)

export const BMRPageComponent = dynamic<BMRPageProps>(() =>
  import('components/pages/healthTools/bmr').then(
    (mod) => mod.BMRToolPage as any,
  ),
)
export const PWGPageComponent = dynamic<PWGPageProps>(() =>
  import('components/pages/healthTools/pwg').then((mod) => mod.PWGToolPage),
)
export const THRPageComponent = dynamic<THRPageProps>(() =>
  import('components/pages/healthTools/thrPage').then((mod) => mod.THRToolPage),
)

export const OvulationPageComponent = dynamic<OvulationPageProps>(() =>
  import('components/pages/healthTools/ovulation').then(
    (mod) => mod.OvulationPageComponent,
  ),
)
export const BabyVaccinePageComponent = dynamic<BabyVaccinationPageAllProps>(
  () =>
    import('components/pages/healthTools/babyVaccine').then(
      (mod) => mod.BabyVaccinationPage,
    ),
)

export const BabyGrowthPageComponent = dynamic<
  (BabyGrowthPageProps | BabyGrowthResultPageProps) & {
    type: BabyGrowthPageType
  }
>(() =>
  import('components/pages/healthTools/babyGrowth/index').then(
    (mod) => mod.BabyGrowthPage,
  ),
)
export const BabyPoopPageComponent = dynamic<BabyPoopPageProps>(() =>
  import('components/pages/healthTools/babyPoop').then(
    (mod) => mod.BabyPoopPage,
  ),
)
